import { useMutation } from 'react-query';

import { updateGateTemplate as mutationFn } from 'api/endPoints/updateGateTemplate';

import { ICreateTemplate } from 'components/pages/PhasePerformanceManagePage/components/Manage/Manage.types';

export const useMutationUpdateTemplate = () => {
    return useMutation<unknown, QueryError, ICreateTemplate>((params) => mutationFn(params));
};
